export enum SupportedCurrencies {
  EUR = 'EUR',
  USD = 'USD',
}
